import styled from 'styled-components';
import { TriggerTextMixin } from '../../mixins/components/TriggerTextMixin';

/**
 * Inline trigger style used for `Tooltip` and `Popover` components in a body of text.
 *
 * `TriggerText` is normally used as a child of a `Popper` or `TooltipPopper`.
 *
 * @related ['Popover', 'Tooltip', 'Trigger', 'TriggerButton']
 * @since 7.0.0
 */
var TriggerText = /*#__PURE__*/styled.button.withConfig({
  displayName: "TriggerText",
  componentId: "c11n-8-111-0__sc-d96jze-0"
})(["", ""], TriggerTextMixin);
TriggerText.displayName = 'TriggerText';
TriggerText.defaultProps = {
  // Prevents submits when included in a form tag
  type: 'button'
};

/** @component */
export { TriggerText };